// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerPartNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsCustomerPartNumber";
import { css } from "styled-components";

customerPartNumberStyles.labelText = {
    size: 14,
    weight: "bold",
    css: css`
        display: block;
        letter-spacing: 0;
        line-height: 16px;
        &:after {
            content: ":";
        }
    `,
};

customerPartNumberStyles.valueText = {
    size: 14,
    weight: 400,
    css: css`
        letter-spacing: 0;
        line-height: 21px;
    `,
};
